export type OrderSummaryMessages = {
  // Titles
  orderSummaryTitle: string;

  // Labels
  productTotalLabel: string;
  deliveryFeeLabel: string;
  discountsLabel: string;
  chargesLabel: string;
  totalPriceLabel: string;
};

export const ORDER_SUMMARY_MESSAGES: OrderSummaryMessages = {
  // Titles
  orderSummaryTitle: "Resumo do Pedido",

  // Labels
  productTotalLabel: "Produtos",
  deliveryFeeLabel: "Frete",
  discountsLabel: "Descontos",
  chargesLabel: "Encargos",
  totalPriceLabel: "Total",
};
